import { ColumnDefinition } from '../../dto/column-definition';

export class FilterInput<T> {
  constructor(
    public min: T | null,
    public max: T | null,
    public from: T | null,
    public to: T | null,
    public col: ColumnDefinition
  ) {}
}
